import { rootApi } from '../rootApi';
import { HTTPRequestType } from '../api.types';
import {
  IInboundAlias,
  IInboundEmailLog,
  ListInboundEmailLogsParams,
  ManuallyAssignParams,
} from './inbound-email.types';

interface PaginatedLogs {
  results: IInboundEmailLog[];
  count: number;
}

export const inboundEmailApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getInboundAlias: builder.query<IInboundAlias, string>({
      query: (organizationId: string) => ({
        url: `/organizations/${organizationId}/inbound-alias`,
      }),
      providesTags: ['InboundAlias'],
    }),

    rotateInboundAlias: builder.mutation<IInboundAlias, string>({
      query: (organizationId: string) => ({
        url: `/organizations/${organizationId}/inbound-alias/rotate`,
        method: HTTPRequestType.POST,
      }),
      invalidatesTags: ['InboundAlias'],
    }),

    setInboundAliasEnabled: builder.mutation<
      IInboundAlias,
      { organizationId: string; enabled: boolean }
    >({
      query: ({ organizationId, enabled }) => ({
        url: `/organizations/${organizationId}/inbound-alias/enabled`,
        method: HTTPRequestType.PATCH,
        data: { enabled },
      }),
      invalidatesTags: ['InboundAlias'],
    }),

    listInboundEmailLogs: builder.query<PaginatedLogs, ListInboundEmailLogsParams>({
      query: ({ organizationId, ...params }) => ({
        url: `/organizations/${organizationId}/inbound-email-logs`,
        params,
      }),
      providesTags: ['InboundEmailLogs'],
    }),

    manuallyAssignInboundEmailLog: builder.mutation<IInboundEmailLog, ManuallyAssignParams>({
      query: ({ organizationId, logId, jobId }) => ({
        url: `/organizations/${organizationId}/inbound-email-logs/${logId}/manually-assign`,
        method: HTTPRequestType.POST,
        data: { job_id: jobId },
      }),
      invalidatesTags: ['InboundEmailLogs', 'InboundAlias'],
    }),
  }),
});

export const {
  useGetInboundAliasQuery,
  useRotateInboundAliasMutation,
  useSetInboundAliasEnabledMutation,
  useListInboundEmailLogsQuery,
  useManuallyAssignInboundEmailLogMutation,
} = inboundEmailApi;
